/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Ingestion_DescInputs */

const es_prompt_tips_ingestion_desc = /** @type {(inputs: Prompt_Tips_Ingestion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencioná si los archivos involucrados ya fueron ingeridos en el sistema o si todavía están pendientes. Esto ayuda al agente a buscar en el lugar correcto.`)
};

const en_prompt_tips_ingestion_desc = /** @type {(inputs: Prompt_Tips_Ingestion_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mention whether the files involved have already been ingested into the system or are still pending. This helps the agent search in the right place.`)
};

/**
* | output |
* | --- |
* | "Mention whether the files involved have already been ingested into the system or are still pending. This helps the agent search in the right place." |
*
* @param {Prompt_Tips_Ingestion_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_ingestion_desc = /** @type {((inputs?: Prompt_Tips_Ingestion_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Ingestion_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_ingestion_desc(inputs)
	return en_prompt_tips_ingestion_desc(inputs)
});
export { prompt_tips_ingestion_desc as "prompt_tips.ingestion_desc" }